import { sanitizeHtml } from '@/common/utils/html-sanitizer'
import {
  readHtmlTagAttributes,
  wrapHtmlInnerWithRootAttributes,
} from '@/common/utils/mhtmlRootWrapper'

export function isHtmlMessage(message: string): boolean {
  if (!message || typeof message !== 'string') return false
  const trimmed = message.trim().toLowerCase()
  return trimmed.startsWith('<html>') || trimmed.startsWith('<html ')
}

function unescapeHtmlEntities(html: string): string {
  if (!html.includes('&lt;') && !html.includes('&gt;')) {
    return html
  }

  return html
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, '/')
}

function extractHtmlMessageBody(html: string): string {
  if (!html || typeof html !== 'string') {
    return ''
  }

  const trimmed = html.trim()
  const lowerTrimmed = trimmed.toLowerCase()

  if (!lowerTrimmed.startsWith('<html')) {
    return trimmed
  }

  const bodyMatch = trimmed.match(/<body[^>]*>\s*(.*?)\s*<\/body>/is)
  if (bodyMatch?.[1]) {
    return bodyMatch[1].trim()
  }

  const htmlOpenMatch = trimmed.match(/<html\b([^>]*)>/is)
  const htmlMatch = trimmed.match(/<html[^>]*>\s*(.*?)\s*<\/html>/is)
  if (htmlMatch?.[1]) {
    let content = htmlMatch[1].trim()
    content = content.replace(/<head[^>]*>.*?<\/head>/is, '')
    const rootTag = htmlOpenMatch ? `<html${htmlOpenMatch[1]}>` : '<html>'
    return wrapHtmlInnerWithRootAttributes(content.trim(), rootTag)
  }

  return trimmed
}

export function prepareDialogMessageContent(message: string): { isHtml: boolean; content: string } {
  const normalized = String(message ?? '').replace(/\\n/g, '\n')
  const unescaped = unescapeHtmlEntities(normalized)
  if (!isHtmlMessage(unescaped)) {
    return { isHtml: false, content: unescaped }
  }

  const body = extractHtmlMessageBody(unescaped.trim())
  return {
    isHtml: true,
    content: sanitizeHtml(body),
  }
}
